import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = l((e, r) => /* @__PURE__ */ o.jsx(
  a,
  {
    ref: r,
    ...e,
    image: (s) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...s,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13.187 5.031C13.983 3.696 13.022 2 11.467 2H5a3 3 0 0 0-3 3v11c0 7.732 6.268 14 14 14s14-6.268 14-14V5a3 3 0 0 0-3-3h-6.467c-1.555 0-2.516 1.696-1.72 3.031 1.313 2.2 3.039 5.105 4.117 6.969a8 8 0 1 1-13.86 0 705 705 0 0 1 4.117-6.969M16 21a5 5 0 1 0 0-10 5 5 0 0 0 0 10",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
i.displayName = "CloggedPoresIcon";
export {
  i as CloggedPoresIcon,
  i as default
};
//# sourceMappingURL=index.js.map
